import React, { useState, useRef}  from 'react';
import advert1 from '../Assets/fmcad1.png';
import advert2 from '../Assets/fmcad2.png';
import advertsm1 from '../Assets/fmcadsm1.png';
import fmc from "../Assets/fmc.png";
import { useTranslation } from 'react-i18next';

function Ad(props) {
    const { t } = useTranslation();
    const [ad, setAd] = useState(0);
    const ads =[advert1, advert2];
    const urls = ["https://www.fmccrop.com.au/en/products/herbicides/spotlight-plus.htm",
    "https://www.fmccrop.com.au/en/products/insecticides/avatar_evo.htm"]

    const adssm =[advertsm1];
    const urlssm = ["https://www.fmccrop.com.au/en/products/insecticides/altacor-x-force.htm"]

    const intervalRef = useRef();
    
    const AD_DURATION = 5000;
    
    function flipAd() {
        if (!props.small) {
            // need to get value from previous state
            setAd(prevAd => prevAd === 0 ? 1 : 0);
        }
    }

    React.useEffect(() => {
        if (intervalRef.current) {
            // the component is mounted several times for some reason,
            // this will ensure the interval is only set once
            clearInterval(intervalRef.current);
        }
        intervalRef.current = setInterval(flipAd, AD_DURATION);
        return () => {
            clearInterval(intervalRef.current)
        };
    }, []);    

    const handleMouse = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            // explicitly clear the intervalRef
            intervalRef.current = null;
        }
        else {
            intervalRef.current = setInterval(flipAd, AD_DURATION);
        }
    };

    return (
        <div className={"card align-items-center justify-content-center"} style={{ background: "#FFF"}}>
            <div className="d-flex align-items-center justify-content-center m-1"
                 onMouseEnter={handleMouse} onMouseLeave={handleMouse}>
                <a id='adLink' href={props.small ? urlssm[ad] : urls[ad]} target="_blank" rel="noreferrer">
                    <img src={props.small ? adssm[ad] : ads[ad]} alt="" style={{height: "auto", width: "100%", objectFit: "contain", maxHeight: '22rem'}}/>
                </a>
            </div>
            <div style={{width: '100%'}}>
              <h5 className="m-1 font-weight-light fs-12 float-right">
                {t('topBar.sponsoredBy')} <img style={{ height: "32px" }} src={fmc} alt="FMC logo" />
              </h5>
            </div>
        </div>
    );
}

export default Ad;